(function () {
  'use strict';


  function clearFeaturedBadges(grid) {
    Array.prototype.slice.call(grid.querySelectorAll('.grid-product__preset-badge--featured')).forEach(function (badge) {
      badge.parentNode.removeChild(badge);
    });
  }

  function addFeaturedBadge(card) {
    if (card.querySelector('.grid-product__preset-badge--featured')) return;

    // Overlaid directly on the product photo (top-left), not in the text
    // info block below it, per request — a corner "ribbon" reads faster
    // than a badge buried among the rating/price text.
    var imgWrap = card.querySelector('.bb-card__img-wrap');
    if (!imgWrap) return;

    var badge = document.createElement('span');
    badge.className = 'grid-product__preset-badge grid-product__preset-badge--featured product-quiz-bb-featured-badge';
    badge.textContent = 'Featured';
    imgWrap.insertBefore(badge, imgWrap.firstChild);
  }

  function updateVisibleCardColumns(grid) {
    var cards = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.classList && el.classList.contains('bb-card');
    });

    var visibleIndex = 0;
    cards.forEach(function (card) {
      card.classList.remove('product-quiz-bb-card--column-left', 'product-quiz-bb-card--column-right');

      if (card.hidden || window.getComputedStyle(card).display === 'none') return;

      card.classList.add(visibleIndex % 2 === 0
        ? 'product-quiz-bb-card--column-left'
        : 'product-quiz-bb-card--column-right');
      visibleIndex += 1;
    });
  }

  function applyFeaturedHandles(grid, handles) {
    clearFeaturedBadges(grid);

    handles.forEach(function (handle) {
      handle = handle.trim();
      if (!handle) return;

      var card = grid.querySelector('.bb-card[data-product-handle="' + handle + '"]');
      if (!card) return;

      if (card.classList.contains('bb-card--loading')) {
        // Card hasn't finished loading its product data yet — retry once
        // bundle-builder-page.js swaps in the real markup.
        var observer = new MutationObserver(function () {
          if (!card.classList.contains('bb-card--loading')) {
            observer.disconnect();
            addFeaturedBadge(card);
          }
        });
        observer.observe(card, { attributes: true, attributeFilter: ['class'] });
        return;
      }

      addFeaturedBadge(card);
    });
  }

  // Moves every card whose handle is in this result's bundle ahead of the
  // rest, in their existing relative order on both sides. Keyed off
  // data-product-handle, which Liquid renders on the skeleton placeholder
  // before bundle-builder-page.js fetches each product's real content, so
  // this doesn't need to wait for cards to finish loading like the badge
  // above does — reordering a still-loading skeleton card is fine, and
  // filling its innerHTML in afterward doesn't disturb sibling order.
  function reorderFeaturedFirst(grid, handles) {
    var handleSet = {};
    handles.forEach(function (handle) {
      handle = handle.trim();
      if (handle) handleSet[handle] = true;
    });
    if (!Object.keys(handleSet).length) return;

    var cards = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.classList && el.classList.contains('bb-card');
    });

    var featured = [];
    var rest = [];
    cards.forEach(function (card) {
      if (handleSet[card.getAttribute('data-product-handle')]) {
        featured.push(card);
      } else {
        rest.push(card);
      }
    });

    // appendChild on a node already in the DOM moves it — re-appending in
    // the desired order is enough, no removal/insertion bookkeeping needed.
    featured.concat(rest).forEach(function (card) {
      grid.appendChild(card);
    });

    updateVisibleCardColumns(grid);
  }

  function applyFromResultEl(resultEl) {
    var grid = document.getElementById('bbProductGrid');
    if (!grid || !resultEl) return;

    var handlesAttr = resultEl.getAttribute('data-bundle-handles');
    if (!handlesAttr) return;

    var handles = handlesAttr.split(',');
    applyFeaturedHandles(grid, handles);
    reorderFeaturedFirst(grid, handles);
  }

  function handleResultShown(event) {
    var resultEl = event.detail && event.detail.resultEl;
    if (!resultEl) {
      var tag = event.detail && event.detail.tag;
      if (!tag) return;
      resultEl = document.querySelector('.product-quiz__result[data-result-tag="' + tag + '"]');
    }
    applyFromResultEl(resultEl);
  }

  document.addEventListener('product-quiz:result-shown', handleResultShown);

  applyFromResultEl(document.querySelector('.product-quiz__result:not([hidden])'));


  if (!document.querySelector('.product-quiz')) return;

  // bundle-builder-page.js re-parents #bbProductModal to <body> (fixing a
  // separate viewport-sizing bug: any transformed ancestor — like this
  // quiz's results panel, which sets one for its drag-position-offset
  // feature — becomes the containing block for position:fixed content).
  // That move takes the modal out from under
  // .product-quiz__bundle-builder-wrap, so the DOM-ancestry-scoped rules in
  // product-quiz-bundle-builder-embed.css (star restyle, hiding the review
  // count) can no longer reach it. This marker class gives those rules a
  // way back in without depending on where the modal physically lives.
  var bbModal = document.getElementById('bbProductModal');
  if (bbModal) bbModal.classList.add('product-quiz-bb-modal');

  var ORDINALS = { '1': '1st', '2': '2nd', '3': '3rd', '4': '4th' };
  var DEFAULT_SLOT_TEXT = 'Select a product';

  function relabelReadMoreButtons(root) {
    Array.prototype.slice.call(root.querySelectorAll('.bb-card__read-more')).forEach(function (btn) {
      if (btn.textContent !== 'Select') btn.textContent = 'Select';
    });
  }

  function relabelSlotText(slotText, ordinal) {
    if (slotText.textContent === DEFAULT_SLOT_TEXT) {
      slotText.textContent = 'Select Your ' + ordinal + ' Product';
    }
  }

  function relabelCtaLabel(ctaLabel) {
    if (ctaLabel.textContent !== 'Add to Cart') ctaLabel.textContent = 'Add to Cart';
  }

  var grid = document.getElementById('bbProductGrid');
  if (grid) {
    var columnUpdateFrame = null;
    var scheduleColumnUpdate = function () {
      if (columnUpdateFrame) return;
      columnUpdateFrame = window.requestAnimationFrame(function () {
        columnUpdateFrame = null;
        updateVisibleCardColumns(grid);
      });
    };

    updateVisibleCardColumns(grid);
    new MutationObserver(scheduleColumnUpdate).observe(grid, {
      attributes: true,
      attributeFilter: ['style', 'hidden'],
      childList: true,
      subtree: true
    });
    window.addEventListener('resize', scheduleColumnUpdate);

    relabelReadMoreButtons(grid);
    new MutationObserver(function () {
      relabelReadMoreButtons(grid);
    }).observe(grid, { childList: true, subtree: true });
  }

  if (grid) {
    grid.addEventListener('click', function (event) {
      var readMoreBtn = event.target.closest('.bb-card__read-more');
      if (!readMoreBtn) return;

      var card = readMoreBtn.closest('.bb-card');
      if (!card) return;

      var addBtn = card.querySelector('.bb-card__add-btn');
      var variantTrigger = card.querySelector('[data-variant-trigger]');
      if (!addBtn && !variantTrigger) return; // e.g. sold out — nothing to redirect to

      event.preventDefault();
      event.stopImmediatePropagation();

      if (addBtn) {
        addBtn.click();
      } else {
        variantTrigger.click();
      }
    }, true);
  }

  var toastEl = null;
  var toastHideTimer = null;

  function ensureToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'product-quiz-bb-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    toastEl.innerHTML = '<span class="product-quiz-bb-toast__icon" aria-hidden="true">&#10003;</span>'
      + '<span class="product-quiz-bb-toast__text"></span>';
    document.body.appendChild(toastEl);
    return toastEl;
  }

  function showAddedToast(title) {
    var toast = ensureToast();
    toast.querySelector('.product-quiz-bb-toast__text').textContent = (title || 'Product') + ' added';
    toast.classList.add('is-visible');
    if (toastHideTimer) window.clearTimeout(toastHideTimer);
    toastHideTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  if (grid) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var card = mutation.target;
        if (!card.classList || !card.classList.contains('bb-card')) return;

        if (card.classList.contains('is-selected')) {
          if (card.__pqToastArmed) return;
          card.__pqToastArmed = true;
          showAddedToast(card.getAttribute('data-product-title'));
        } else {
          card.__pqToastArmed = false;
        }
      });
    }).observe(grid, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  var slots = document.getElementById('bbSlots');
  if (slots) {
    Array.prototype.slice.call(slots.querySelectorAll('.bb-aside__slot')).forEach(function (slot) {
      var ordinal = ORDINALS[slot.getAttribute('data-slot-index')];
      var slotText = slot.querySelector('.bb-aside__slot-text');
      if (!ordinal || !slotText) return;

      relabelSlotText(slotText, ordinal);
      new MutationObserver(function () {
        relabelSlotText(slotText, ordinal);
      }).observe(slotText, { childList: true, characterData: true, subtree: true });
    });
  }

  var ctaLabel = document.querySelector('#bbAddToCart .bb-aside__cta-label');
  if (ctaLabel) {
    relabelCtaLabel(ctaLabel);
    new MutationObserver(function () {
      relabelCtaLabel(ctaLabel);
    }).observe(ctaLabel, { childList: true, characterData: true, subtree: true });
  }

  // bundle-builder-page.js disables #bbAddToCart until the minimum tier
  // quantity is met, but gives no explanation why — surface that here
  // rather than in the shared file, since it's only confusing in this
  // one-featured-item quiz context (the standalone page's own grid makes
  // the "add more to unlock" tier copy elsewhere on the page already).
  var addToCartBtn = document.getElementById('bbAddToCart');
  if (addToCartBtn) {
    var minTierQty = (window.BB_PAGE_DATA && window.BB_PAGE_DATA.tiers && window.BB_PAGE_DATA.tiers.length)
      ? window.BB_PAGE_DATA.tiers[0].qty
      : 2;

    var ctaNotice = document.createElement('p');
    ctaNotice.className = 'product-quiz-bb-cta-notice';
    ctaNotice.textContent = 'Add at least ' + minTierQty + ' items to enable the bundle purchase.';
    addToCartBtn.insertAdjacentElement('afterend', ctaNotice);

    var syncCtaNotice = function () {
      ctaNotice.style.display = addToCartBtn.disabled ? '' : 'none';
    };
    syncCtaNotice();
    new MutationObserver(syncCtaNotice).observe(addToCartBtn, { attributes: true, attributeFilter: ['disabled'] });
  }
})();
